import React, { useEffect, useState, lazy, Suspense } from "react";
// import { IFront } from "../../components/cars/front/850i";
// import { IRear } from "../../components/cars/rear/850i";
// import { PORGTFront } from "../../components/cars/front/PORGT";
// import { PORGTRear } from "../../components/cars/rear/PORGT";
// import { RRFront } from "../../components/cars/front/RR";
// import { RRRear } from "../../components/cars/rear/RR";
// import { RSRear } from "../../components/cars/rear/RS";
// import { RSFront } from "../../components/cars/front/RS";
// import { TaycanRear } from "../../components/cars/rear/Taycan";
// import { TaycanFront } from "../../components/cars/front/Taycan";
// import { TransporterFront } from "../../components/cars/front/Transporter";
// import { TransporterRear } from "../../components/cars/rear/Transporter";
// import { TrocFront } from "../../components/cars/front/Troc";
// import { TrocRear } from "../../components/cars/rear/Troc";
import download from "../../assets/images/download.svg";
import domtoimage from "dom-to-image";
import Loader from "../../components/Loader";
import arrow from "../../assets/images/arrow.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API, verifySite } from "../../utils/api";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import useRecaptcha from "../../hooks/useRecaptcha";
import useWindowSize from "../../hooks/useWindowSize";
import LoaderWithBG from "../../components/LoaderWithBG";

const IFront = lazy(() => import("../../components/cars/front/850i"));
const IRear = lazy(() => import("../../components/cars/rear/850i"));
const PORGTFront = lazy(() => import("../../components/cars/front/PORGT"));
const PORGTRear = lazy(() => import("../../components/cars/rear/PORGT"));
const RRFront = lazy(() => import("../../components/cars/front/RR"));
const RRRear = lazy(() => import("../../components/cars/rear/RR"));
const RSRear = lazy(() => import("../../components/cars/rear/RS"));
const RSFront = lazy(() => import("../../components/cars/front/RS"));
const TaycanRear = lazy(() => import("../../components/cars/rear/Taycan"));
const TaycanFront = lazy(() => import("../../components/cars/front/Taycan"));
const M2Rear = lazy(() => import("../../components/cars/rear/M2"));
const M2Front = lazy(() => import("../../components/cars/front/M2"));
const TransporterFront = lazy(() =>
  import("../../components/cars/front/Transporter")
);
const TransporterRear = lazy(() =>
  import("../../components/cars/rear/Transporter")
);
const TrocFront = lazy(() => import("../../components/cars/front/Troc"));
const TrocRear = lazy(() => import("../../components/cars/rear/Troc"));

const PlateViewer = (props) => {
  const [numberPlate, setNumberPlate] = useState("");
  const [registration, setRegistration] = useState("");
  const [error, setError] = useState("");
  const [width, height] = useWindowSize();
  const [token] = useRecaptcha();
  const givenCars = [
    {
      id: 1,
      name: "BMW 850i Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <IFront numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 2,
      name: "BMW 850i Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <IRear numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 3,
      name: "Porsche GT Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <PORGTFront numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 4,
      name: "Porsche GT Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <PORGTRear numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 5,
      name: "Range Rover Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <RRFront numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 6,
      name: "Range Rover Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <RRRear numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 7,
      name: "Audi RS4 Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <RSFront numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 8,
      name: "Audi RS4 Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <RSRear numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 9,
      name: "Porsche Taycan Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <TaycanFront numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 10,
      name: "Porsche Taycan Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <TaycanRear numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 11,
      name: "Transporter Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <TransporterFront numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 12,
      name: "Transporter Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <TransporterRear numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 13,
      name: "T-roc Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <TrocFront numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 14,
      name: "T-roc Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <TrocRear numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 15,
      name: "M2 Front",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <M2Front numberPlate={registration} />
        </Suspense>
      ),
    },
    {
      id: 16,
      name: "M2 Rear",
      component: (
        <Suspense fallback={<LoaderWithBG />}>
          <M2Rear numberPlate={registration} />
        </Suspense>
      ),
    },
  ];

  const cars = props?.cars ? [...props?.cars, ...givenCars] : [...givenCars];

  const [selectedCar, setSelectedCar] = useState(cars[0].id);

  const onDownload = (e) => {
    e?.preventDefault();
    if (!registration) {
      setError("Please enter registration");
      return;
    }
    setError("");
    setLoading(true);
    const el = document.querySelector(
      ".genrator__menu--image-inner .image-div svg"
    );
    el.classList.remove("width-full");
    const element = document.querySelector(
      ".genrator__menu--image-inner .image-div"
    );
    element.classList.remove("width-full");
    domtoimage.toPng(element).then((url) => {
      const link = document.createElement("a");
      link.href = url;
      link.download = "download.png";
      document.body.appendChild(link);
      link.click();
      el.classList.add("width-full");
      setLoading(false);
      document.body.removeChild(link);
    });
  };

  // useEffect(() => {
  //   const observer = new MutationObserver((mutationsList) => {
  //     for (let mutation of mutationsList) {
  //       if (mutation.type === 'childList') {
  //         const el = document.querySelector(".genrator__menu--image-inner .image-div svg");
  //         if (el) {
  //           el.classList.add("width-full");
  //           observer.disconnect(); // Stop observing once the class is added
  //         }
  //       }
  //     }
  //   });

  //   const targetNode = document.querySelector(".genrator__menu--image-inner .image-div");
  //   if (targetNode) {
  //     observer.observe(targetNode, { childList: true, subtree: true });
  //   }

  //   // Clean up the observer on component unmount or when selectedCar changes
  //   return () => {
  //     observer.disconnect();
  //   };
  // }, [selectedCar]);

  useEffect(() => {
    if (props?.registration) {
      setRegistration(props?.registration);
    }
  }, [props]);

  const [lodding, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      middle_initials: "",
      last_name: "",
      email: "",
      phone_no: "",
      description: "",
      subscribe: false,
      submitting: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .matches(/^[A-Za-z\s]*$/, "Invalid characters")
        .required("Please enter first name"),
      middle_initials: Yup.string()
        .matches(/^[A-Za-z\s]*$/, "Only characters")
        .notRequired(),
      last_name: Yup.string()
        .matches(/^[A-Za-z\s]*$/, "Invalid characters")
        .required("Please enter last name"),

      email: Yup.string()
        .email("Invalid email")
        .required("Please enter your email.")
        .matches(/@.*\./, "Domain name is required"),
      phone_no: Yup.string()
        .transform((value) => (value ? value.replace(/\s/g, "") : value)) // Remove spaces
        // .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
        .required("Please enter phone number"),

      submitting: Yup.boolean().oneOf(
        [true],
        "By submitting this form, you are agreeing to REG247’s"
      ),

      description: Yup.string().required("Please enter description"),
      subscribe: Yup.boolean().notRequired(),
    }),

    onSubmit: (values) => {
      verifySite(token);
      // Your login logic here using the form values
      // For example, you can authenticate the user and navigate upon successful login
      const {
        first_name,
        middle_initials,
        last_name,
        email,
        phone_no,
        description,
        subscribe,
      } = values;

      console.log("values", first_name);

      setLoading(true);
      try {
        const body = {
          first_name: first_name,
          middle_initials: middle_initials,
          last_name: last_name,
          email: email,
          phone_number: phone_no,
          message: description,
          is_subscribe: subscribe,
          type: 2,
        };

        console.log("body", body);

        API("contactUs", "post", body, "")
          .then((response) => {
            document.querySelector("body").scrollTo(0, 0);
            setLoading(false);
            setVisible(true);
            formik.resetForm();
            console.log("responce", response);
          })
          .catch((error) => {
            setLoading(false);
            console.log("catch error:", error);
          });
      } catch (error) {
        console.log("catch error message: ", error);

        setLoading(false);
      }
      // Perform authentication logic here...

      // For demonstration purposes, let's assume authentication is successful
      // Redirect the user to the home page
      // localStorage.setItem(constants.USER, email); // Storing user in localStorage
      // navigate('/');
    },
  });

  let nonSpaceEntered = false;

  const renderToast = () => {
    return (
      <div
        className={`alert alert-success text-start d-flex border-0 align-items-center justify-content-between ${
          visible ? "visible" : "hidden"
        }`}
      >
        <span>
          Thanks for your enquiry, one of the team will get back to you soon.
        </span>
        <span
          role="button"
          className="close-btn"
          onClick={() => setVisible(false)}
        >
          &#x2715;
        </span>
      </div>
    );
  };

  function isValidNumberPlatePrifix(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern = /^[A-Z]\d{1,3}\s?[A-Z]{3}$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }
  function isValidNumberPlateSuffix(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern = /^[A-Z]{3}\s?\d{1,3}[A-Z]$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }
  function isValidNumberPlateCurrent(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern =
        /^[ABCDEFGHJKLMNOPRSTVWXY]{2}\d{2}\s?[ABCDEFGHJKLMNOPRSTVWXY]{3}$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }
  function isValidNumberPlateDateless(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern = /^[A-Z]{1,5}\s?\d{1,5}$|^\d{1,5}\s?[A-Z]{1,5}$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }

  const handleRegistrationChange = (event) => {
    // const newRegistration = event.target.value.toUpperCase();
    const newRegistration = event.target.value.toUpperCase();
    setRegistration(newRegistration);
  };

  const btnClick = () => {
    console.log("object");
    let plate = registration.trimStart();
    console.log("pl", plate);
    if (isValidNumberPlateDateless(plate)) {
      setError("");
      if (!/\s/.test(plate)) {
        // Check if there's already a space
        setRegistration(plate.replace(/([a-zA-Z])(\d)/g, "$1 $2"));
      }
    } else if (isValidNumberPlatePrifix(plate)) {
      setError("");
      if (!/\s/.test(plate)) {
        setRegistration(
          plate.substring(0, plate.length - 3) +
            " " +
            plate.substring(plate.length - 3)
        );
      }
    } else if (isValidNumberPlateSuffix(plate)) {
      setError("");
      if (!/\s/.test(plate)) {
        setRegistration(plate.substring(0, 3) + " " + plate.substring(3));
      }
    } else if (isValidNumberPlateCurrent(plate)) {
      setError("");
      if (!/\s/.test(plate)) {
        setRegistration(
          plate.substring(0, plate.length - 3) +
            " " +
            plate.substring(plate.length - 3)
        );
      }
    } else {
      if (registration) {
        setError("Not a valid plate format");
      }
      // const midpoint = Math.ceil(plate.length / 2);
      // if (!/\s/.test(plate)) {
      //   setRegistration(
      //     plate.substring(0, midpoint) + " " + plate.substring(midpoint)
      //   );
      // }
    }

    // Check the type of the new registration plate
  };

  return (
    <div className="main__page__content">
      <Helmet
        onChangeClientState={(newState) => {
          const metaDescription = document.querySelector(
            'meta[name="description"]'
          );
          if (metaDescription) {
            metaDescription.setAttribute(
              "content",
              "Discover how your perfect registration looks on a selection of cars. Our free number plate viewer tool also allows you to download." ||
                ""
            );
          }
        }}
      >
        <title>Number Plate Viewer - View a Plate on Different Cars</title>
      </Helmet>
      {lodding && <LoaderWithBG />}
      <main>
        <div className="reg__enquiry">
          <div className="reg__enquiry--data pt-45 pb-45">
            <div className="container">
              <h2 className="f36 fsi text-white">
                Need some help?{" "}
                <span className="text-green f36 fsi">
                  Call us on{" "}
                  <a className="text-green f36 fsi" href="tel:01582347734">
                    <u>
                      <b>01582 347734</b>
                    </u>
                  </a>
                </span>
              </h2>
            </div>
          </div>
        </div>
        <section className="genrator__menu--section reg__plate--vivewer pt-45 pb-45">
          <div className="container">
            {visible && width < 768 && renderToast()}
            <div className="reg__section--heading mb-50">
              <h1 className="f36 fys">Plate Viewer</h1>
            </div>
            <div className="row justify-between">
              <div className="genrator__menu--inner col-lg-8">
                <div className="genrator__menu--center">
                  {/*image--col*/}
                  <div
                    className="genrator__menu--image-inner right-line"
                    onClick={() => btnClick()}
                  >
                    <div className="image-div text-center plate-generator-box mx-auto">
                      {
                        cars?.filter((car) => car?.id == selectedCar)[0]
                          ?.component
                      }
                      {/* <img
                        src="./assets/images/car5.png"
                        alt=""
                        className="img-fluid w-100"
                      />
                      <div className="plate-generator-text porsche d-flex align-items-center justify-content-center position-absolute">
                        DR 1
                      </div> */}
                    </div>
                  </div>
                </div>
                {/**/}
                <div className="genrator__menu--footer">
                  <div className="row">
                    <div className="col col-12">
                      <div className="genrator__menu--footer-inner mx-auto">
                        <form
                          action=""
                          id="create-valuation-form"
                          className="form fsi"
                        >
                          {!props?.isProduct && (
                            <>
                              <h2 className="fs-3 mb-2 text-500 fys">
                                Plate Viewer
                              </h2>
                              <hr />
                              {/*text-input*/}
                              <label htmlFor="reg" className="text-400">
                                {" "}
                                Registration
                              </label>
                              <br />
                              <input
                                type="text"
                                name="reg"
                                maxLength={8}
                                className="w-100 text-400"
                                // value={numberPlate}
                                value={registration}
                                // onChange={(e) =>
                                //   setNumberPlate(e.target.value.trimStart())
                                // }
                                onChange={handleRegistrationChange}
                                onBlur={btnClick}
                              />
                              {error && (
                                <div className="text-danger fs-6 mt-1">
                                  {error}
                                </div>
                              )}
                              <br />
                            </>
                          )}

                          {/*select-dropdown*/}
                          <label htmlFor="format" className="text-400">
                            {" "}
                            Choose a display mode
                          </label>
                          <div className="select__inner">
                            <select
                              name="format"
                              className="select mb-10 w-100 text-400"
                              value={selectedCar}
                              onChange={(e) => setSelectedCar(e.target.value)}
                            >
                              {cars.map((car) => (
                                <option
                                  value={car.id}
                                  key={car?.id}
                                  className="fsi"
                                >
                                  {car.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <br />
                          <br />
                          {/*submit--btn*/}
                          <div className="reg__hero--section p-0">
                            <div className="reg__buy--button download__button d-block">
                              <button
                                type="submit"
                                className="d-flex align-items-center justify-content-center gap-2"
                                onClick={onDownload}
                              >
                                {" "}
                                <img
                                  src={download}
                                  alt="download-icon"
                                  className="in-svg w-100 img-fluid m-0 pr-5"
                                />{" "}
                                Download as image
                              </button>
                            </div>
                          </div>
                          <br />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 order-lg-1 reg__help--form">
                <h5 className="fys text-300 lh32 mb-15">How can we help?</h5>
                <div className="reg__list--data ms-auto border rounded-2 p-45 pt-30">
                  {visible && width > 768 && renderToast()}
                  <form
                    className="row fsi text-400 enquiry__form"
                    onSubmit={formik.handleSubmit}
                  >
                    {/* First Name */}
                    <div className="col-12 col-sm-4 col-lg-12 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        First Name<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputAddress"
                          placeholder="First Name"
                          value={formik.values.first_name}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "first_name",
                              e.target.value?.trimStart()
                            );
                          }}
                        />
                      </div>
                      {formik.touched.first_name &&
                        formik.errors.first_name && (
                          <div className="text-danger">
                            {formik.errors.first_name}
                          </div>
                        )}
                    </div>
                    {/* Surname */}
                    <div className="col-12 col-sm-4 col-lg-12 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        Middle Initials
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputAddress2"
                          placeholder="Initial"
                          value={formik.values.middle_initials}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "middle_initials",
                              e.target.value?.trimStart()
                            );
                          }}
                        />
                      </div>
                      {formik.touched.middle_initials &&
                        formik.errors.middle_initials && (
                          <div className="text-danger">
                            {formik.errors.middle_initials}
                          </div>
                        )}
                    </div>
                    {/* Email */}
                    <div className="col-12 col-sm-4 col-lg-12 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        Last Name<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputCity"
                          placeholder="Last Name"
                          value={formik.values.last_name}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "last_name",
                              e.target.value?.trimStart()
                            );
                          }}
                        />
                      </div>
                      {formik.touched.last_name && formik.errors.last_name && (
                        <div className="text-danger">
                          {formik.errors.last_name}
                        </div>
                      )}
                    </div>

                    {/* Phone Email */}
                    <div className="col-12 col-lg-12 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        Phone
                        <span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputCity"
                          placeholder="Phone"
                          value={formik.values.phone_no}
                          onChange={(e) => {
                            let input = e.target.value;
                            const regex = /^[0-9\s]*$/; // Regular expression to allow only numbers and spaces
                            if (!nonSpaceEntered) {
                              // If no non-space character entered yet, trim spaces
                              input = input.trimStart();
                            }
                            if (regex.test(input) || input === "") {
                              formik.setFieldValue("phone_no", input);
                              // Check if a non-space character has been entered
                              if (input !== "" && !nonSpaceEntered) {
                                nonSpaceEntered = true;
                              }
                            }
                          }}
                        />
                      </div>
                      {formik.touched.phone_no && formik.errors.phone_no && (
                        <div className="text-danger">
                          {formik.errors.phone_no}
                        </div>
                      )}
                    </div>

                    {/* Confirm Email */}
                    <div className="col-12 col-lg-12 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        Email<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputCity"
                          placeholder="example@mail.com"
                          value={formik.values.email}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "email",
                              e.target.value?.trimStart()
                            );
                          }}
                        />
                      </div>
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </div>
                    {/* Phone */}
                    {/* <div class="col-12 col-md-6 mb-15">
                                  <label class="f16" for="">Phone</label>
                                  <div class="input-group bg-image fnumber">
                                      <div class="input-group-text border-0 rounded-0 bg-transparent p15 green-image border-end br-2 border-color">+91</div>
                                      <input type="number" class="form-control p16 border-0" id="inputCity" placeholder="phone">
                                  </div>
                              </div> */}
                    {/* Street Address */}
                    <div className="col-12 mb-50">
                      <label className="f16 mb-10" htmlFor="">
                        Message<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="form__price input-group bg-image">
                        <textarea
                          type="text"
                          className="form-control p16 border-0"
                          rows={6}
                          cols={5}
                          id="inputCity"
                          placeholder="Write here"
                          defaultValue={""}
                          value={formik.values.description}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "description",
                              e.target.value?.trimStart()
                            );
                          }}
                        />
                      </div>
                      {formik.touched.description &&
                        formik.errors.description && (
                          <div className="text-danger">
                            {formik.errors.description}
                          </div>
                        )}
                    </div>

                    <div className="col-12">
                      <div
                        className="form-check mb-20 "
                        style={{ alignItems: "center" }}
                      >
                        <input
                          id="unsubscribe1"
                          className="form-check-input"
                          type="checkbox"
                          checked={formik.values.submitting}
                          onChange={(e) =>
                            formik.setFieldValue("submitting", e.target.checked)
                          }
                        />
                        <label
                          className={
                            formik.touched.submitting &&
                            formik.errors.submitting
                              ? "form-check-label text-danger "
                              : "form-check-label "
                          }
                          htmlFor="unsubscribe1"
                        >
                          By submitting this form, you are agreeing to REG247’s{" "}
                          <Link
                            to="/privacy-policy"
                            className="privacy-link"
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            <span
                              // className="f16"
                              className={
                                formik.touched.submitting &&
                                formik.errors.submitting
                                  ? "form-check-label text-danger f16"
                                  : "form-check-label f16"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              privacy policy
                            </span>
                          </Link>
                          <span className="f24">*</span>
                        </label>
                      </div>
                    </div>

                    <div className="col-12 mb-15">
                      <div className="form-check mb-50 d-block">
                        <div className="reg__subscribe-check d-flex">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="unsuscribe"
                            checked={formik.values.subscribe}
                            onChange={(e) =>
                              formik.setFieldValue(
                                "subscribe",
                                e.target.checked
                              )
                            }
                          />
                          <label
                            className="form-check-label  text-400 lh28 mb-15"
                            htmlFor="unsuscribe"
                          >
                            Subscribe for special offers, discounts and number
                            plates that may be relevant to me. I understand that
                            I can unsubscribe at any time.
                          </label>
                        </div>
                        {/* <p className="f16 pl-9" htmlFor="unsuscribe">
                          We will not share your details with any third parties.
                          We may contact you in accordance with our&nbsp;{' '}
                          <Link to={'/privacy-policy'} className="f16">
                            <u>Privacy Policy</u>
                          </Link>
                          . You can unsubscribe any time.
                        </p> */}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-check fsubmit_btn mb-0">
                        <button
                          type="submit"
                          className="reg__sell--submit btn text-uppercase f24 lh14 d-flex align-center justify-center"
                        >
                          SEND{" "}
                          <img
                            class="in-svg ml-25"
                            src={arrow}
                            alt="Arrow image"
                          />
                        </button>
                      </div>
                    </div>
                    {/* </div> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PlateViewer;
